import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	Fab,
	Box,
	SwipeableDrawer,
	List as MuiList,
	Grid,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	ListItemSecondaryAction,
} from "@mui/material";
import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";
import { Add } from "@mui/icons-material";
import useStore from "../../store/store";
import billService from "../../services/bill";
import style from "../../utils/style";
import utils from "../../utils/utils";
import { SearchBar, ArrowUpChip } from "../../controls";
import PageHeading from "../../components/PageHeading";
import AddBill from "../../components/AddBill";
import NoDataFound from "../../components/NoDataFound";
import Confirm from "../../components/Confirm";

function Bills() {
	let [keyword, setKeyword] = useState("");
	let [bills, setBills] = useState([]);
	let [isDone, setIsDone] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [openConfirm, setOpenConfirm] = useState(false);

	const navigate = useNavigate();
	const {
		token,
		setErrorMessage,
		setSuccessMessage,
		setIsLoading,
		isLoggedIn,
		currObj,
		setCurrObj,
	} = useStore((state) => state);

	useEffect(() => {
		if (!isLoggedIn) navigate("/login");
		reload();
	}, [keyword]);

	const toggleDrawer = () => setIsOpen(!isOpen);

	const reload = () => {
		setIsLoading(true);
		billService.reload(token, keyword).then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			if (r.data) {
				setBills(r.data);
				setIsLoading(false);
				setIsDone(true);
			}
		});
	};

	const deleteRecord = () => {
		setIsLoading(true);
		billService
			.delete(token, currObj._id)
			.then((res) => {
				if (res.error) {
					setErrorMessage(res.error);
					setIsLoading(false);
					return;
				}

				setSuccessMessage("Bill deleted successfully.");
				setIsOpen(false);
				setIsLoading(false);
				setCurrObj(null);
				reload();
			})
			.catch((err) => {
				setErrorMessage(err.message);
			});
	};

	const Puller = styled(Box)(() => ({
		width: 30,
		height: 6,
		backgroundColor: "#ccc",
		borderRadius: 3,
		position: "absolute",
		top: 8,
		left: "calc(50% - 15px)",
	}));

	return (
		<>
			<Confirm
				open={openConfirm}
				onNo={() => {
					setOpenConfirm(false);
				}}
				onYes={() => {
					setOpenConfirm(false);
					deleteRecord();
				}}
				title="Are you sure?"
				body="This bill will be deleted."
			/>

			<Fab
				color="primary"
				aria-label="add"
				onClick={() => {
					toggleDrawer();
				}}
				style={{ position: "fixed", right: 20, bottom: 80 }}
			>
				<Add />
			</Fab>

			<Global
				styles={{
					".MuiDrawer-root > .MuiPaper-root": {
						height: `calc(80%)`,
						overflow: "visible",
						borderTopLeftRadius: 10,
						borderTopRightRadius: 10,
					},
				}}
			/>

			<SwipeableDrawer
				anchor="bottom"
				open={isOpen}
				onClose={() => {
					setCurrObj(null);
					toggleDrawer();
				}}
				onOpen={toggleDrawer}
				swipeAreaWidth={56}
				disableSwipeToOpen={true}
				ModalProps={{
					keepMounted: true,
				}}
			>
				<Puller />
				<AddBill toggleDrawer={toggleDrawer} reload={reload} />
			</SwipeableDrawer>

			<Grid container sx={style.container}>
				<Grid item xs={12} sx={{ mb: 1 }}>
					<PageHeading text="Bills" />
				</Grid>

				<Grid item xs={12}>
					<SearchBar keyword={keyword} setKeyword={setKeyword} />
				</Grid>

				{isDone && bills.length > 0 && (
					<Grid item xs={12} md={12}>
						<MuiList
							sx={{
								width: "100%",
								bgcolor: "background.paper",
								p: 0,
								m: 0,
							}}
						>
							{bills.map((row, idx) => (
								<ListItem
									key={idx}
									sx={{ m: 0, p: 1, cursor: "pointer" }}
									onClick={() => {
										navigate(`/bill-details?id=${row._id}`);
									}}
								>
									<ListItemText
										primary={row.title}
										secondary={utils.formatToCurrency(
											row.arr.reduce(
												(a, b) => a + b.price,
												0
											) +
												(row.arr.reduce(
													(a, b) => a + b.totalWeight,
													0
												) /
													100) *
													2,
											"Rs."
										)}
									/>

									<ListItemSecondaryAction sx={{ right: 1 }}>
										<ion-icon
											style={{ color: "red" }}
											name="trash-outline"
											onClick={() => {
												setCurrObj(row);
												setOpenConfirm(true);
											}}
										></ion-icon>
									</ListItemSecondaryAction>
								</ListItem>
							))}
						</MuiList>
						{bills.length >= 12 && <ArrowUpChip />}
					</Grid>
				)}
				{isDone && bills.length === 0 && (
					<Grid item xs={12}>
						<NoDataFound />
					</Grid>
				)}
			</Grid>
		</>
	);
}

export default Bills;
